import { Typography } from "@packages/ds";
import styled, { css as styledCSS } from "styled-components";

import * as Table from "ds/Table";

export const Row = styled(Table.Tr)<{ $isInvitation: boolean }>`
  text-decoration: none;

  ${({ $isInvitation }) =>
    !!$isInvitation &&
    styledCSS`
    ${Typography.BodyText} {
        color: var(--label-granite-color,var(--granite));
    }
  `};
`;

export const AccessCell = styled(Table.Td)`
  display: flex;
  flex: 1;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const GraniteText = styled(Typography.BodyText)`
  color: var(--label-granite-color, var(--granite));
`;

export const TextSeparation = styled.div`
  margin-left: 8px;
`;
